import React from 'react';
import { useLoaderData } from 'react-router-dom';
import AsideTopic from './AsideTopic';
import './aside.css';

const Aside = () => {
    const data = useLoaderData();
    console.log(data);
    return (
        <div className='bg-white pb-3 rounded-start shadow-lg'>
            <h5 className='text-center pt-4 pb-1' >Courses</h5>
            {
                data.map((sd) => <AsideTopic
                key={sd.id}
                sd={sd}
                ></AsideTopic>)
            }
        </div>
    );
};

export default Aside;